<template>
    <el-dialog @open="init" v-bind="$attrs"
        :visible="visible" custom-class="dap-single-select-dialog" :title="title"
        :modal-append-to-body="false" @close="closeDialog" :close-on-click-modal="false"
    >

        <div class="dialog-content">
            <slot></slot>
            <DapSingleSelectPanel ref="singleSelect" v-bind="$attrs" :selectRow="selectRowDialog" @select="val => selectRowDialog = val">
                <template #table-header="{column, scope, row, tableData}">
                    <slot name="table-header" :column="column" :scope="scope" :row="row" :tableData="tableData"></slot>
                </template>
                <template #table-body="{column, scope, row, tableData}">
                    <slot name="table-body" :column="column" :scope="scope" :row="row" :tableData="tableData"></slot>
                </template>
            </DapSingleSelectPanel>
            <div slot="footer" class="dialog-footer m-t-10">
                <el-button @click="closeDialog" size="mini">取 消</el-button>
                <el-button type="primary" @click="confirm" size="mini">确 定</el-button>
            </div>
        </div>

    </el-dialog>
</template>

<script>
import DapSingleSelectPanel from './SingleSelectPanel';

export default {
    name: 'DapSingleSelectDialog',
    components: {
        DapSingleSelectPanel,
    },
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        title: {
            type: String,
            default: '',
        },
        selectRow: {
            type: Object,
            default: () => ({}),
        },
    },
    computed: {
    },
    data () {
        return {
            selectRowDialog: {},
            search: '',
        };
    },
    methods: {
        init () {
            this.selectRowDialog = this.selectRow;
            this.$nextTick(() => {
                console.log('this.$refs.singleSelect', this.$refs.singleSelect);
                this.$refs.singleSelect.getData(1);
            });
        },
        closeDialog () {
            this.selectRowDialog = {};
            this.$emit('update:visible', false);
        },

        confirm () {
            // 传出数据
            this.$emit('select', this.selectRowDialog);
            this.closeDialog();
        },
    },
};
</script>

<style lang="scss">
    .dap-single-select-dialog {
        text-align: left;
        width: 710px;
        min-width: 710px;
        .el-dialog__title {
            font-weight: 400;
        }
        .el-dialog__body {
            padding: 10px 20px 20px 20px;
            .el-input-group__append {
                width: 32px;
                background-color: #fff;
                padding: 0;
                text-align: center;
            }
        }
        .dialog-footer {
            text-align: right;
        }

        .select-area {
            display: flex;
            flex-direction: column;
            .select-title-row {
                background: #F8F8F8;
                border: 1px solid #E9E9EB;
                height: 40px;
                .select-title {
                    line-height: 40px;
                    padding-left: 44px;
                }
            }

            .select-content {
                flex: auto;
                border: 1px solid #E9E9EB;
                border-top: none;
                overflow: auto;
                position: relative;
                ul {
                    list-style-type:none;
                    padding-left: 0;
                    margin: 0;
                    li {
                        height: 40px;
                        line-height: 40px;
                        padding-left: 20px;
                        display: flex;
                        align-items: center;
                        cursor: pointer;
                        .el-radio {
                            margin-right: 0;
                            transform: translate(0, 2px);
                        }

                        &:hover {
                            background-color: #f5f7fa;
                            color: #4284F4;

                            i.fa {
                                color: #4284F4;
                            }
                        }
                    }
                }
            }
        }
    }
</style>
